import { Accordion } from '@/components/AccordionSideMenu';
import {
  BackButton,
  Item,
  SmallContent,
} from '@/components/NewHeader/SideMenu/helperComponents';
import { useTranslation } from '@/contexts/dictionaryContext';
import useGTMEvents from '@/hooks/useGTMEvents';
import { useState } from 'react';

export function Guides() {
  const {
    newHeader: { guides, nav },
  } = useTranslation();
  const [value, setValue] = useState(guides.sicilyGuides.title);

  const { sendMenuClickEvent } = useGTMEvents();

  const section = nav.find((item) => item.id === 'guides')?.title || 'Guides';

  const handleItemClick = (item: { title: string; href: string }) =>
    sendMenuClickEvent({ section, sectionItem: item.title });

  return (
    <>
      <BackButton />

      <Accordion
        type="single"
        collapsible
        className="w-full bg-black/5"
        value={value}
        onValueChange={setValue}>
        <Item
          value={guides.sicilyGuides.title}
          isOpen={value === guides.sicilyGuides.title}>
          <SmallContent
            onItemClick={handleItemClick}
            items={guides.sicilyGuides.items}
          />
        </Item>
        <Item
          value={guides.pugliaGuides.title}
          isOpen={value === guides.pugliaGuides.title}>
          <SmallContent
            onItemClick={handleItemClick}
            items={guides.pugliaGuides.items}
          />
        </Item>
      </Accordion>
    </>
  );
}
